RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    views.DualGraphBarPart = Marionette.View.extend({
        initialize: function (options) {
            const me = this;
            me.options = options;
        },

        onDestroy: function () {
            const me = this;
            me.$el.popover('destroy');
        },

        render: function () {
            const me = this;
            const el = me.$el;
            const model = me.model;
            const options = me.options || {};
            const toPercent = d3.format('p');

            if (options.sum !== 0) {
                const percent = model.get('value') / options.sum;
                el.css('width', toPercent(Math.abs(percent)));
            }

            if (me.options.color) {
                el.attr('style', `${el.attr('style')}background-color: ${me.options.color} !important;`);
            }

            const cls = model.get('class');

            if (typeof cls === 'function') {
                el.addClass(cls(model));
            } else if (cls) {
                el.addClass(cls);
            }

            const tooltip = model.get('tooltip');
            if (tooltip) {
                RivalIQ.utils.tooltip.addPopover(el, tooltip, {
                    placement: me.getOption('tooltipPlacement')
                });
            }

            return me;
        }
    });

}, window.d3);
